import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Paper,
  Divider,
  List,
  ListItem,
  ListItemText,
  TextField,
  Button,
  Dialog,
  IconButton,
  DialogContent,
  DialogActions,
} from "@mui/material";
import coupan_icon from "../../../assets/images/coupan_icon.svg";
import correct_icon from "../../../assets/images/correct_icon.svg";
import Classes from "./OrderSummary.module.css";
import {
  ArrowRight,
  Check,
  CloseOutlined,
} from "@mui/icons-material";
import { useNavigate, useOutletContext } from "react-router-dom";
import axios from "axios";
import {
  authApi,
  getAuthorizationHeader,
} from "../../../api-calls/user-requests";
import { toast } from "react-toastify";
import loadRazorpayScript from "../../../utilities/loadRazorpay";
import { MY_SUBSCRIPTION, PAYMENT_SUCCESS } from "../../../api-calls/api-urls";
import { useRazorpaySubscriptionCheckout } from "../../../hooks/useRazorpaySubscriptionCheckout";
const OrderSummary = () => {
  const navigator = useNavigate();
  const { plans } = useOutletContext();
  const { startRecurringCheckout } = useRazorpaySubscriptionCheckout();
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [prmodetails, setPrmodetails] = useState([]);
  const [selectedPromo, setSelectedPromo] = useState(null);
  const [selectedDuration, setSelectedDuration] = useState(null);
  console.log(selectedDuration);
  console.log(selectedPlan);

  useEffect(() => {
    const selectedDurationId = localStorage.getItem("selctedplan_id");
    console.log(selectedDurationId);

    // Find the matching duration object
    for (const plan of plans) {
      const duration = plan.durations.find((d) => d._id === selectedDurationId);
      if (duration) {
        setSelectedPlan(plan);
        setSelectedDuration({ ...duration, packageName: plan.packageName });
        break;
      }
    }
    getPromocode();
  }, [plans]);

  const getPromocode = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}/promo-code/getlist`,
        {
          headers: { Authorization: getAuthorizationHeader() },
        }
      );
      console.log(data);
      setPrmodetails(data?.promolist);
    } catch (e) {
      console.log(e);
    }
  };
  const [openCouponDialog, setOpenCouponDialog] = useState(false);

  const handleOpenCoupon = () => setOpenCouponDialog(true);
  const handleCloseCoupon = () => {
    setOpenCouponDialog(false);
    setCouponCode("");
    setSelectedPromo(null);
  };
  const [couponCode, setCouponCode] = useState("");
  const basePrice = selectedDuration?.price || 0;
  const gstPercent = 18;
  const discount = selectedPromo?.data?.discount || 0;
  const gstAmount = (basePrice * gstPercent) / 100;
  const priceWithGST = Number(basePrice) + Number(gstAmount);
  const total = Math.max(priceWithGST - discount, 0);

  const handleCouponChnage = (e) => {
    if (e.target.value.length > 10) {
      return;
    }
    setCouponCode(e.target.value);
  };

  const handleApplyCoupon = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}/promo-code/checkpromo/${couponCode}`,
        {
          headers: { Authorization: getAuthorizationHeader() },
        }
      );
      if (data) {
        setSelectedPromo(data);
        setOpenCouponDialog(false);
      }
    } catch (e) {
      setSelectedPromo(null);
      toast.error(e.response?.data?.message || "Invalid coupon");
      console.log(e);
    }
  };

  const handlePaymentButton = async () => {
    try {
      // Recurring subscriptions bill Razorpay's fixed plan price with no
      // per-checkout discount hook yet, so a promo code in play still routes
      // through the legacy one-time flow (which does support it) rather than
      // silently dropping the discount.
      if (selectedDuration?.razorpay_plan_id && !selectedPromo) {
        await startRecurringCheckout({
          subscriptionId: selectedPlan._id,
          durationId: selectedDuration._id,
          description: "TeamPlayer Subscription",
          onAuthorized: async () => {
            navigator("/payment_success");
          },
        });
        return;
      }

      const res = await loadRazorpayScript(
        "https://checkout.razorpay.com/v1/checkout.js"
      );

      if (!res) {
        alert("Razorpay SDK failed to load. Are you online?");
        return;
      }

      // Step 1: Create DB order first so we have an order to link the payment to
      const subRes = await authApi.post(
        MY_SUBSCRIPTION,
        {
          subscriptionid: selectedPlan._id,
          durationid: selectedDuration._id,
        },
        { headers: { Authorization: getAuthorizationHeader() } }
      );
      const dbOrder = subRes.data?.data;
      if (!dbOrder?._id) {
        toast.error("Unable to create order. Please try again.");
        return;
      }

      // Step 2: Create Razorpay order using the DB order amount
      const { data } = await axios.post(
        `${process.env.REACT_APP_API_URL}/my-subscriptions/create-order`,
        {
          amount: total,
          currency: "INR",
          receipt: `receipt_${dbOrder._id}`,
          // Lets the server price the checkout from the order and approve
          // the coupon before any money moves.
          order_id: dbOrder._id,
          ...(selectedPromo
            ? { referral_code: selectedPromo.data.referral_code }
            : {}),
        },
        { headers: { Authorization: getAuthorizationHeader() } }
      );

      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID,
        amount: data.order.amount,
        currency: data.order.currency,
        name: "Team Player App",
        description: "Payment for subscription",
        order_id: data.order.id,
        handler: async (response) => {
          try {
            // Step 3: Verify payment signature
            const verifyRes = await axios.post(
              `${process.env.REACT_APP_API_URL}/my-subscriptions/verify-order`,
              {
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
              },
              { headers: { Authorization: getAuthorizationHeader() } }
            );
            if (verifyRes.data.success) {
              // Step 4: Activate subscription on the DB order with payment details
              const paymentEntry = {
                userid: dbOrder.user_id,
                orderid: dbOrder._id,
                payment_details: {
                  razorpay_order_id: response.razorpay_order_id,
                  razorpay_payment_id: response.razorpay_payment_id,
                  razorpay_signature: response.razorpay_signature,
                },
              };
              if (selectedPromo) {
                paymentEntry.referral_code = selectedPromo.data.referral_code;
              }
              await authApi.post(PAYMENT_SUCCESS, paymentEntry, {
                headers: { Authorization: getAuthorizationHeader() },
              });
              navigator("/payment_success");
            } else {
              alert("Payment Verification Failed.");
            }
          } catch (err) {
            toast.error(err.response?.data?.message || "Something went wrong after payment.");
          }
        },
        theme: {
          color: "#528FF0",
        },
        modal: {
          ondismiss: () => {
            toast.error("Payment Cancelled!");
          },
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.on("payment.failed", function (response) {
        console.error("Payment failed:", response);
        alert("Payment Failed!\nReason: " + response.error.description);
      });
      rzp.open();
    } catch (error) {
      console.log("Payment Error:", error);
      toast.error(error.response?.data?.message || "Something went wrong. Please try again.");
    }
  };
  return (
    <Box maxWidth="lg" mx="auto" mt={4} sx={{ fontSize: "20px" }}>
      <Dialog open={openCouponDialog} onClose={handleCloseCoupon} maxWidth="xs">
        <div className={Classes.couponDialog}>
          <div>
            <IconButton
              aria-label="close"
              onClick={handleCloseCoupon}
              sx={{ position: "absolute", right: 8, top: 8 }}
            >
              <CloseOutlined sx={{ color: "black" }} />
            </IconButton>
          </div>
          <div className={Classes.couponHeader}>
            <p className={Classes.couponTitle}>Apply Coupon Code</p>
            <p style={{ fontSize: "16px", color: "#6B778C" }}>
              Have a promo code? Enter it below to get an instant discount on
              your total.
            </p>
          </div>
          <DialogContent sx={{ width: "100%", padding: "0px" }}>
            <p className={Classes.couponText}>Enter coupon code here:</p>
            <TextField
              fullWidth
              placeholder="Enter coupon code"
              variant="outlined"
              value={couponCode} // ✅ Fix: use correct state
              onChange={(e) => handleCouponChnage(e)} // ✅ Fix: pass event, not e.target.value
            />
            <Typography
              variant="caption"
              mt={1}
              sx={{
                color: "#6B778C",
              }}
            >
              saved ₹720 from the code above
            </Typography>

            <Box>
              <Typography
                variant="body2"
                sx={{ color: "#6B778C" }}
                textAlign={"center"}
                fontWeight="bold"
                gutterBottom
                mt={4}
                mb={4}
              >
                Or
              </Typography>
              <div>
                <p style={{ fontWeight: "bold" }}>Apply</p>
                {prmodetails.map((item) => (
                  <Box
                    key={item.code}
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    p={1}
                    borderBottom="1px solid #ccc"
                    mt={1}
                  >
                    <Box display="flex" alignItems="center" gap={1}>
                      <img src={coupan_icon} alt="coupan_icon" />
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <Typography variant="body2">
                          {item.referral_code}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          save ₹{item?.discount}
                        </Typography>
                      </div>
                    </Box>
                    <Button
                      size="small"
                      variant="text"
                      onClick={() => setCouponCode(item.referral_code)}
                    >
                      Apply
                    </Button>
                  </Box>
                ))}
              </div>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              onClick={handleApplyCoupon}
              sx={{ marginTop: "27px", width: "100%", height: "56px" }}
            >
              Apply Coupon
            </Button>
          </DialogActions>
        </div>
      </Dialog>

      <Typography
        variant="h6"
        fontWeight="bold"
        gutterBottom
        sx={{ textAlign: "center", fontFamily: "Roboto, sans-serif" }}
      >
        Order Summary
      </Typography>
      <Typography
        variant="body2"
        color="#136FB2"
        gutterBottom
        sx={{ textAlign: "center" }}
      >
        Review your selected plan before proceeding.
      </Typography>

      <Grid container spacing={4} mt={2}>
        {/* Plan Details */}
        <Grid item xs={12} md={5.5}>
          <div className={Classes.heading_div}>
            <Typography
              variant="h6"
              fontWeight="bold"
              gutterBottom
              sx={{ color: "black" }}
            >
              {selectedPlan?.packageName}
            </Typography>
          </div>
          <div className={Classes.price_container}>
            <div className={Classes.price_div}>
              <div className={Classes.price_details}>
                <div style={{ fontSize: "20px", fontWeight: "600" }}>
                  Duration :
                </div>
                <p
                  style={{
                    fontSize: "20px",
                    fontWeight: "500",
                    marginTop: "10px",
                  }}
                >
                  {" "}
                  ₹{selectedDuration?.price}/{" "}
                  <span style={{ color: "#888" }}>
                    {selectedDuration?.duration}
                  </span>{" "}
                </p>
              </div>
              <div style={{ fontSize: "20px", fontWeight: "500" }}>
                Exc. of GST
              </div>
            </div>

            <Box>
              <div className={Classes.team_details}>
                <div className={Classes.team_package_heading}>
                  No. of Team members that can <br /> be added :
                </div>
                <div style={{ color: "#666" }}>
                  Upto {selectedPlan?.noOfTeamMembers}
                </div>
              </div>
            </Box>
            <Box mt={2}>
              <Typography fontWeight="bold" gutterBottom>
                Features
              </Typography>
              <List dense>
                {selectedPlan?.features.map((text, index) => (
                  <ListItem key={index}>
                    <div
                      style={{
                        width: "34px",
                        height: "34px",
                        borderRadius: "50%",
                        display: "flex",
                        justifyContent: "center",
                        backgroundColor: "#EFF6FF",
                        marginRight: "16px",
                        alignItems: "center",
                      }}
                    >
                      <Check color="primary" sx={{ fontSize: "24px" }} />
                    </div>
                    {/* <ListItemIcon>
                    </ListItemIcon> */}
                    <ListItemText
                      primary={text.feature}
                      primaryTypographyProps={{
                        fontSize: "20px",
                        color: "#6B778C",
                      }}
                    />
                  </ListItem>
                ))}
              </List>
            </Box>
          </div>
        </Grid>
        {/* Price Summary */}
        <Grid item xs={12} md={6.2}>
          <Paper elevation={1} sx={{ p: 3 }}>
            <Paper sx={{ width: "70%", padding: "30px", marginTop: "60px" }}>
              <Box
                display="flex"
                justifyContent="space-between"
                sx={{ paddingBottom: "24px" }}
              >
                <Typography fontSize={"20px"} fontWeight={"500"}>
                  Base Price
                </Typography>
                <Typography fontSize={"20px"} fontWeight={"500"}>
                  ₹{basePrice}
                </Typography>
              </Box>
              <Divider sx={{ my: 2 }} />
              <Box
                display="flex"
                justifyContent="space-between"
                mt={"24px"}
                sx={{ paddingBottom: "24px" }}
              >
                <Typography fontSize={"20px"} fontWeight={"500"}>
                  GST ({gstPercent}%)
                </Typography>
                <Typography fontSize={"20px"} fontWeight={"500"}>
                  ₹{gstAmount}
                </Typography>
              </Box>
              {selectedPromo?.data?.discount && (
                <Box
                  display="flex"
                  justifyContent="space-between"
                  mt={"24px"}
                  sx={{ paddingBottom: "24px" }}
                >
                  <Typography fontSize={"20px"} fontWeight={"500"}>
                    Discount{" "}
                  </Typography>
                  <Typography fontSize={"20px"} fontWeight={"500"}>
                    ₹{selectedPromo?.data?.discount}
                  </Typography>
                </Box>
              )}

              <Divider sx={{ my: 2 }} />
              <Box display="flex" justifyContent="space-between" mt={"24px"}>
                <Typography variant="h6" fontWeight="bold">
                  Total
                </Typography>
                <Typography variant="h6" fontWeight="bold">
                  ₹{total}
                </Typography>
              </Box>
              <Box mt={"60px"}>
                <Typography variant="caption" color="text.secondary">
                  This plan auto-renews monthly. Cancel anytime from settings.
                </Typography>
              </Box>
            </Paper>

            <Box mt={3}>
              <Box display="flex" alignItems="center" gap={1}>
                <img src={coupan_icon} alt="coupan_icon" />

                <Typography
                  variant="body2"
                  fontWeight="bold"
                  sx={{
                    cursor: "pointer",
                    fontSize: "20px",
                    display: "flex",
                    alignItems: "center",
                  }}
                  onClick={handleOpenCoupon}
                >
                  {selectedPromo?.data?.discount
                    ? "Coupon code Applied"
                    : "Apply Coupon Code"}
                  {selectedPromo?.data?.discount ? (
                    <img
                      src={correct_icon}
                      alt="correct_icon"
                      style={{ marginLeft: "4px" }}
                    />
                  ) : (
                    <ArrowRight sx={{ color: "#000" }} />
                  )}
                </Typography>
              </Box>
            </Box>

            <Box mt={8} display="flex" gap={"30px"}>
              <Button
                variant="outlined"
                color="primary"
                sx={{ padding: "20px 90px", fontSize: "24px" }}
                onClick={() => navigator("/register-success")}
              >
                Cancel
              </Button>
              <button
                style={{
                  padding: "20px 0x",
                  width: "266px",
                  fontSize: "24px !important",
                  border: "none",
                  borderRadius: "4px",
                  color: "white",
                  backgroundColor: "#227DC3",
                  fontWeight: 400,
                }}
                onClick={handlePaymentButton}
              >
                Proceed to Payment{" "}
              </button>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default OrderSummary;
